import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IonToolbar } from '@ionic/angular/standalone';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonToolbar],
  host: {
    style: 'display: contents'
  },
})
export class ToolbarComponent {
  readonly extraPadding = input<boolean>(false);
  readonly noPaddingRight = input<boolean>(false);
  readonly noPaddingLeft = input<boolean>(false);
  readonly padLeft = input<boolean>(false);
  readonly padRight = input<boolean>(false);
  readonly noPaddingBottom = input<boolean>(false);
}
